import React from "react";
import {
  Field,
  reduxForm,
  stopSubmit,
  formValueSelector,
  FieldArray,
} from "redux-form";
import { Form, FormGroup, Label, Alert, Button } from "reactstrap";
import { connect } from "react-redux";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import DatePickerOld from "../../system/fields/DatePickerOld";
import WYSIWYG from "../../system/fields/Wysiwyg";
import ReactTable from "react-table";
import * as validations from "../../system/utils/Validation";
import ExcursionsWrapper from "./components/ExcursionsWrapper";
import TravellerWrapper from "./components/TravellerWrapper";

const renderExcursions = ({ fields, meta: { touched, error } }) => (
  <div className="repeater-container">
    <Button
      type="button"
      onClick={() =>
        fields.push({
          excursion_title: "",
          excursion_price: "",
          excursion_summary: "",
          excursion_image: "",
        })
      }
    >
      Add Excursion
    </Button>
    {fields.map((excursion, index) => (
      <ExcursionsWrapper
        excursion={excursion}
        fields={fields}
        index={index}
        key={index}
      />
    ))}
  </div>
);

const renderTraveller = ({ fields, meta: { touched, error } }) => (
  <div className="repeater-container">
    <Button
      type="button"
      onClick={() => fields.push({ traveller_name: "", traveller_dob: "" })}
    >
      Add Additional Traveller
    </Button>
    {fields.map((traveller, index) => (
      <TravellerWrapper
        traveller={traveller}
        fields={fields}
        index={index}
        key={index}
      />
    ))}
  </div>
);

const columns = [
  {
    accessor: "id",
    Header: "Booking Ref",
    Cell: (props) => props.value,
  },
  {
    accessor: "due_date",
    Header: "Due Date",
    Cell: (props) => props.value,
  },
  {
    accessor: "price",
    Header: "Price",
    Cell: (props) => props.value,
  },
  {
    accessor: "status",
    Header: "Status",
    Cell: (props) => props.value.name,
  },
];
let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  console.log("this: ", fields);
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Deal Details</div>
          <Label>Deal ID</Label>
          <Field
            name="deal.id"
            component={TextInput}
            type="text"
            validate={validations.required}
            disabled
          />
          <br />
          <div className="form-section-header">Payment Details</div>
          <ReactTable
            data={props.data.payments}
            keyField="id"
            columns={columns}
            defaultPageSize={5}
          />
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label>Booking Status</Label>
              <Field
                name="booking_status"
                component={SelectDropdown}
                options={props.bookingStatus && props.bookingStatus.data.data}
                valueKey="id"
                labelKey="name"
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Travel Date</Label>
              <Field
                name="date_from"
                component={DatePickerOld}
                dateFormat={"MMM dd yyyy h:mm a"}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label>Departure Airport</Label>
              <Field
                name="departure_airport.name"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Number of Travellers</Label>
              <Field
                name="people"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label>Number of Nights</Label>
              <Field
                name="deal.duration"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Total Price</Label>
              <Field
                name="total_price"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12">
              <Label>Notes</Label>
              <Field name="notes" component={WYSIWYG} type="text" />
            </FormGroup>
          </div>

          <div className="form-section-header">Document Details</div>
          <div className="row">
            <FormGroup className="col-12">
              <Label>Documents</Label>
              <Field
                name="documents"
                component={FileUpload}
                multiple
                files
                images
                type="text"
              />
            </FormGroup>
          </div>
          <div className="form-section-header">Excursion Details</div>
          <FieldArray name="excursions" component={renderExcursions} />
          <div className="row">&nbsp;</div>

          <div className="form-section-header">Lead Traveller Details</div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label>First Name</Label>
              <Field name="user.first_name" component={TextInput} type="text" />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Last Name</Label>
              <Field name="user.last_name" component={TextInput} type="text" />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label>Email</Label>
              <Field name="user.email" component={TextInput} type="text" />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Phone Number</Label>
              <Field
                name="user.phone_number"
                component={TextInput}
                type="text"
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Date of birth</Label>
              <Field
                name="date_of_birth"
                component={DatePickerOld}
                dateFormat={"MMM dd yyyy h:mm a"}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Gender</Label>
              <Field
                name={`gender`}
                component={SelectDropdown}
                labelKey={"value"}
                valueKey={"value"}
                clearable={false}
                placeholder="Gender"
                options={[
                  { id: 1, value: "Male" },
                  { id: 2, value: "Female" },
                ]}
                style={{ width: 100, clear: "both" }}
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Address Line 1</Label>
              <Field
                name="address_line_1"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Address Line 2</Label>
              <Field
                name="address_line_2"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Postcode</Label>
              <Field
                name="postcode"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>City</Label>
              <Field
                name="city"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label>Country</Label>
              <Field
                name="country"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>

          <div className="form-section-header">
            Additional Traveller Details
          </div>
          <FieldArray
            name="additional_passengers"
            component={renderTraveller}
          />
          <div className="row">&nbsp;</div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />
            Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

const selector = formValueSelector("BookingForm");

const mapStateToProps = (store) => {
  payment_status: selector(store, "payment_status");
  payments: selector(store, "payments");
};

EditForm = reduxForm({
  form: "BookingForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("BookingForm"));
    }
  },
})(EditForm);

export default connect(mapStateToProps, null)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Bookings/Form.jsx